// extracted by mini-css-extract-plugin
export default {"link":"_7b810bde","wrapper":"_2b25d24d","image":"_a1b85cf9","isFullBleed":"_28118a9d","imageCopy":"_798ef53c"};